import {EntitySnapshot, IterativeSystem} from "tick-knock";
import {Population} from "@game/coregame/view/Population";
import {Building} from "@game/coregame/ecs/entities/Building";
import {StateShapeView} from "@game/coregame/view/StateShapeView";

export class PopulationSystem extends IterativeSystem {
    constructor() {
        super(
            entity =>
                entity.hasAll(Population, StateShapeView) && entity.hasTag(Building.ACTIVE_TAG)
        );
    }

    protected updateEntity(entity: Building, dt: number) {
        const population = entity.get(Population)!;
        population.tryPopulate(dt);
        entity.get(StateShapeView)!.updateWithPopulation(population);
    }
    public entityAdded = (snapshot: EntitySnapshot) => {
        //
    };
}
